import { render } from "./CanvasWorkGroup.vue?vue&type=template&id=14695575&scoped=true"
import script from "./CanvasWorkGroup.vue?vue&type=script&lang=js"
export * from "./CanvasWorkGroup.vue?vue&type=script&lang=js"

import "./CanvasWorkGroup.vue?vue&type=style&index=0&id=14695575&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14695575"]])

export default __exports__